import React, { useState } from "react";
import { createPortal } from "react-dom";
import { FazeDot, etapa, nazevEtapy } from "../lib/faze";
import { ikonaTechnologie } from "../lib/technologie";

/**
 * Technologie případu jako ikony — název (a fáze, když se fáze technologií
 * liší) se ukáže po najetí myší. Čtečka obrazovky čte název z `aria-label`.
 * Na telefonu hover není, tam se technologie dál píšou slovy.
 *
 * Popisek je v portálu s pevnou pozicí: karta na tabuli i buňka seznamu mají
 * `overflow: hidden` a uvnitř by se ořízl.
 */
export default function TechIkony({ technologie = [], sFazi = false }) {
  const [popisek, setPopisek] = useState(null);   // {text, x, y}
  const ukaz = (e, text) => {
    const r = e.currentTarget.getBoundingClientRect();
    setPopisek({ text, x: r.left, y: r.top });
  };
  return (
    <span className="flex flex-wrap gap-1">
      {technologie.map((t) => {
        const Ikona = ikonaTechnologie(t.kategorie_icon);
        const text = sFazi ? `${t.kategorie_name}: ${nazevEtapy(etapa(t))}` : t.kategorie_name;
        return (
          <span key={t.id} role="img" aria-label={text} data-testid={`tech-ikona-${t.id}`}
            onMouseEnter={(e) => ukaz(e, text)} onMouseLeave={() => setPopisek(null)}
            className="relative h-7 w-7 rounded-[8px] bg-inputbg border border-line-strong inline-flex items-center justify-center text-sec">
            <Ikona size={15} strokeWidth={1.8} aria-hidden="true" />
            {sFazi && <FazeDot faze={etapa(t)} className="absolute -top-0.5 -right-0.5 h-2 w-2 ring-2 ring-white" />}
          </span>
        );
      })}
      {popisek && createPortal(
        <span aria-hidden="true" data-testid="tech-popisek"
          style={{ left: Math.max(8, Math.min(popisek.x, window.innerWidth - 248)), top: popisek.y - 6 }}
          className="pointer-events-none fixed z-[70] -translate-y-full max-w-[240px] rounded-[6px] bg-ink text-white text-[11px] font-600 px-2 py-1 shadow-panel">
          {popisek.text}
        </span>,
        document.body,
      )}
    </span>
  );
}
